
const Exceptions = {
    throw(error) {
        throw new Error(error);
    },
    
    getARESemantics(exception) {
        if(exception.semantics) return exception.semantics;
        return Exceptions.evaluations.apiResponse();
    },

    evaluations: {
        login(data, status) {
            const errors = {
                "username-not-found": "Incorrect username or password",
                "password-incorrect": "Incorrect username or password",
                "account-not-confirmed": "Account not yet confirmed by admin",
                400: "Invalid username or password format"
            };

            return evaluateError(errors, data ? data.error : "", status);
        },

        apiResponse(status, error) {
            if(error === "password-incorrect") return {
                title: "Incorrect Password",
                message: "You have entered the wrong password for this account. Try again."
            }

            if(error === "username-exists") return {
                title: "Username already exists",
                message: "The given username is already used."
            };

            if(status > 500) return { 
                title: "Server Error", 
                message: "Something went wrong in the server. Please try again."
            };
            
            if([401, 403].includes(status)) return {
                title: "Unauthorized", 
                message: "You are not allowed to perform this transaction." 
            };
            
            if(status === 400) return {
                title: "Invalid Format", 
                message: "Some values in your form is invalid. Please fix them and try again."
            };

            return {
                title: "Unknown Error", 
                message: "Something went wrong, try again."
            };
        }
    }
};

function evaluateError(reference, name, status) {
    return reference[name] || reference[status] || reference._default || "Unknown Error";
}


export class ResponseException extends Error {
    constructor(response) {
        super();

        this.status = response.status;
        this.message = response.error;
        this.unauthorized = [401, 403].includes(response.status);

        this.semantics = Exceptions.evaluations.apiResponse(this.status, response.data.error);
    }
}

export default Exceptions;